module.exports = __webpack_public_path__ + "static/media/Feinberg.6b4b0309.png";